import { useEffect, useState } from "react";
import useAuthStore from "../../store/useAuthStore";
import { useProfileUpdateStore } from "../../store/useProfileUpdateStore";
import { useUserStore } from "../../store/useUserStore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Password = () => {
  const { activeSection, setActiveSection, updateProfile } = useProfileUpdateStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user.id;
  const user = useUserStore((state) => state.user);
  const getUserDetails = useUserStore((state) => state.getUserDetails);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const toggleCurrentPasswordVisibility = () => {
    setShowCurrentPassword((prev) => !prev);
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };
  

  const [errors, setErrors] = useState<{
    currentPassword?: string;
    newPassword?: string;
    confirmPassword?: string;
  }>({});

  useEffect(() => {
    if (!user || user.id !== userId) {
      getUserDetails(userId);
    }
    
  }, [userId, user, getUserDetails]);

  if (activeSection !== "password") return null;

  const validateForm = () => {
    const newErrors: typeof errors = {};

    if (!currentPassword) newErrors.currentPassword = "Current password is required.";
    if (!newPassword) {
      newErrors.newPassword = "New password is required.";
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters.";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your new password.";
    } else if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    const updatedData = {
      password: {
        currentPassword,
        newPassword,
        confirmPassword,
      },
    };

    await updateProfile(userId, updatedData);
    getUserDetails(userId);
    toast.success("Information updated successfully!");
    // Optionally reset form
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
     setActiveSection(null);
  };

  return (
    <div className=" col-lg-4">
      <div className="card p-lg-4 p-3 border rounded-4 mb-3">
                                        <div className="border-bottom pb-3 mb-3 d-flex w-100 align-items-center gap-3">
                                            <h4 className="mb-0">Update Password</h4>
                                            <button className="btn_close_cross_btn ms-auto " onClick={() => setActiveSection(null)}>
                                                <i className="fa-solid fa-xmark"></i>
                                            </button>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label mb-2 font600 font18">Current Password</label>
                                            <div className="form_field_right_icon">
                                            <input className="form-control mb-1" type={showCurrentPassword ? "text" : "password"} placeholder=""
                                                value={currentPassword}
                                                onChange={(e) => setCurrentPassword(e.target.value)} />
                                                 <i
                                                className={`fa-solid ${showCurrentPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                onClick={toggleCurrentPasswordVisibility}
                                                style={{ cursor: "pointer" }}
                                              ></i>
                                              </div>
                                               {errors.currentPassword && <p className="text-red-500 text-sm">{errors.currentPassword}</p>}   
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label mb-2 font600 font18">New Password</label>
                                            <div className="form_field_right_icon">
                                            <input className="form-control mb-1" type={showPassword ? "text" : "password"} placeholder=""
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}/>
                                                <i
                                                  className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                  onClick={togglePasswordVisibility}
                                                  style={{ cursor: "pointer" }}
                                                ></i>
                                                </div>
                                             {errors.newPassword && <p className="text-red-500 text-sm">{errors.newPassword}</p>}
                                        </div>
                                        <div className="mb-4">
                                            <label className="form-label mb-2 font600 font18">Confirm Password</label>
                                            <div className="form_field_right_icon">
                                            <input className="form-control mb-1" type={showConfirmPassword ? "text" : "password"} placeholder=""
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)} />
                                                <i
                                                  className={`fa-solid ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                  onClick={toggleConfirmPasswordVisibility}
                                                  style={{ cursor: "pointer" }}
                                                ></i>
                                                </div>
                                         {errors.confirmPassword && <p className="text-red-500 text-sm">{errors.confirmPassword}</p>}
                                        </div>
                                        <button className="btn btn-outline-primary w-100"  onClick={handleSave}>
                                            Save Changes</button>
                                    </div>




    </div>
  );
};

export default Password;
